import type { SkyscannerSonarV3Response } from '@skyscanner-internal/sonar-web-http-client';

type PlaceType = SkyscannerSonarV3Response.PlaceType;

export const sonarPlaceType: {
  [Type in PlaceType]: Type;
} = {
  PLACE_TYPE_UNSPECIFIED: 'PLACE_TYPE_UNSPECIFIED',
  PLACE_TYPE_AIRPORT: 'PLACE_TYPE_AIRPORT',
  PLACE_TYPE_CITY: 'PLACE_TYPE_CITY',
  PLACE_TYPE_COUNTRY: 'PLACE_TYPE_COUNTRY',
};
